import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-tests',
  imports: [RouterLink],
  templateUrl: './tests.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tests.css',
})
export class Tests {}
